import {Routes} from '@angular/router';
import {AppVersionComponent, VERSION_PATH} from '@npck/libs/ui-kit';
import {Path} from './path';

export const appRoutes: Routes = [
    {path: Path.ROOT, pathMatch: 'full'},
    {path: VERSION_PATH, component: AppVersionComponent},
];
